import { useState, memo } from 'react';
import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { MainMenu } from 'components/atoms';
import './Header.scss';

const HeaderBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
  position: 'relative',
  backgroundColor: '#f7df1c',
  color: '#000',
  zIndex: theme.zIndex.drawer + 1,
  boxShadow: 'none',
  paddingRight: '16px',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

export interface HeaderProps {
  isHomePage?: boolean;
}

export const Header = memo(({ isHomePage }: HeaderProps) => {
  const [open, setOpen] = useState(false);

  const toggleMenu = () => {
    setOpen((prev) => !prev);
  };

  return (
    <HeaderBar className={isHomePage ? 'hidden-border' : ''}>
      <Toolbar>
        <Typography
          variant="h6"
          component="div"
          sx={{ width: '10rem', position: 'relative', marginBottom: '.3rem' }}
        >
          <Link to="/">
            <img src="/logo.svg" alt="Tuksums" className="logo" fetchPriority="high" decoding="async" width="160" height="40" />
          </Link>
          <p className="logo-subtitle">Emptiness in Latvian</p>
        </Typography>

        <div className="header-content">
          {open && <MainMenu onClose={() => setOpen(false)} />}
          <div className="menu-open" onClick={toggleMenu}>
            Menu
            <img
              src="/images/arrow.svg"
              alt="Menu arrow"
              className={`arrow-image ${open ? 'rotated' : ''}`}
            />
          </div>
        </div>
      </Toolbar>
    </HeaderBar>
  );
});
